import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'error-formly-field-wrapper',
  template: ` <p-divider
      *ngIf="
        props && props.attributes && props.attributes['separator']
      "
    ></p-divider>
    <div class="field p-fluid mb-3 mt-1">
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label class="block"
        >{{ field.templateOptions.label
        }}{{ field.templateOptions.required ? ' *' : '' }}</label
      >
      <ng-container #fieldComponent></ng-container>
      <div
        *ngIf="field.options.showError && field.formControl.errors"
        class="text-sm mt-2 p-error"
      >
        <formly-validation-message
          [field]="field"
        ></formly-validation-message>
      </div>

      <div
        *ngIf="
          field.templateOptions.description &&
          (!field.options.showError || !field.formControl.errors)
        "
        class="text-sm mt-2"
      >
        {{ field.templateOptions.description }}
      </div>

      <div
        *ngIf="
          props && props.attributes && props.attributes['warning']
        "
        class="text-sm my-1 text-yellow-400"
      >
        <span
          class="font-bold"
          i18n
          >Warnung:</span
        >
        {{ props.attributes['warning'] }}
      </div>
    </div>`,
})
export class ErrorFieldWrapperComponent extends FieldWrapper {}
